import { DISPLAY_BREADCRUMBS } from "../actions/types";

export default (breadcrumbs = "", action) => {
  if (action.type === DISPLAY_BREADCRUMBS) {
    return action.payload;
  }
  return breadcrumbs;
};
